<template>
    <layout>
        <div class="news news--archive pb-5">
            <section class="container-fluid pb-sm-5">
                <h1 class="page-title">{{ this.settings.news.title }}</h1>
            </section>
            <section class="container-fluid pb-0">
                <div class="row">
                    <transition name="fade-news" v-for="(news, index) in listNews" :key="index">
                        <div class="col-sm-12 col-md-4 col-lg-3 col-xl-3 pb-4" v-show="showUntil > index">
                            <news-card :news="news" />
                        </div>
                    </transition>
                </div>
            </section>
            <div class="container-fluid d-flex pt-0">
            <a class="nav-link border-link" href @click.prevent="loadPage" v-if="hasMore">Ver mais</a>
            </div>

        </div>
    </layout>
</template>

<script>
    import mixin from '../../mixin';
    import layout from '../../layouts/Main.vue'
    import NewsCard from '../../elements/news/NewsCard';
    import { formatString } from '@config/utils';
    import { mapGetters } from 'vuex';

    export default {
        mixins: [mixin],
        components: {
            NewsCard,
            layout,
        },
        data() {
            return {
                pageID: 'news',
                listNews: [ ],
                page: 0,
                total: undefined,
                showUntil: 0,
            }
        },
        computed: {
            ...mapGetters([ 'getSettings' ]),
            hasMore: function() {
                return this.total > this.page
            },
            settings() {
                return this.getSettings(this.moduleCode, 'home');
            }
        },
        methods: {
            loadPage() {
                const params = { locale: this.locale, page: this.page+1 };
                const url = formatString(this.url.getArchive, params);

                this.$http(url).then(({data}) => {
                    this.listNews = [...this.listNews, ...data.data];
                    this.total = data.meta.last_page;
                    this.page = data.meta.current_page;
                    this.$nextTick(() => {
                        this.showUntil = this.listNews.length;
                    });
                });
            }
        },
        mounted() {
            this.loadPage();
        },
    }
</script>
